import { useSelector } from "react-redux";

import { Settings } from "constants/settings";

import { getSetting } from "selectors";

export function useWeighbridgeKeyboardMode(): boolean {
  return !!useSelector(getSetting(Settings.weighbridgeKeyboardMode));
}
